import React from 'react';
import { FileSearch, LayoutDashboard, LayoutTemplate, Map } from 'lucide-react';
import BrowserFrame from './BrowserFrame';
import platformImage from '../../assets/erica/platform.png';
import mapImage from '../../assets/erica/map.png';
import { COPY } from '../../i18n/copy';
import { useI18n } from '../../i18n/useI18n';

const ICONS = [LayoutDashboard, LayoutTemplate, FileSearch, Map] as const;

const EricaModules: React.FC = () => {
  const { lang } = useI18n();
  const c = COPY[lang];

  return (
    <section id="modules" className="bg-slate-50 py-16 sm:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl">
            {c.modules.title}
          </h2>
          <p className="mt-4 text-lg text-slate-600">{c.modules.subtitle}</p>
        </div>

        <div className="mt-12 grid items-start gap-10 lg:grid-cols-2">
          <div className="relative">
            <BrowserFrame src={platformImage} alt={c.modules.screenshotAlt} />
            <div className="pointer-events-none absolute -bottom-10 -right-6 hidden w-1/2 lg:block">
              <div className="rounded-2xl border border-slate-200 bg-white p-2 shadow-sm">
                <img
                  src={mapImage}
                  alt={lang === 'id' ? 'Tangkapan layar peta ERICA' : 'ERICA map screenshot'}
                  loading="lazy"
                  className="h-auto w-full rounded-xl"
                />
              </div>
            </div>
          </div>

          <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
            <div className="divide-y divide-slate-200">
              {c.modules.items.map((item, idx) => {
                const Icon = ICONS[idx] ?? LayoutDashboard;
                return (
                  <div key={item.title} className="flex items-start gap-4 p-6">
                    <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl border border-slate-200 bg-slate-50">
                      <Icon className="h-5 w-5 text-slate-900" />
                    </div>
                    <div>
                      <h3 className="text-base font-semibold text-slate-900 sm:text-lg">{item.title}</h3>
                      <p className="mt-2 text-sm leading-relaxed text-slate-600">{item.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EricaModules;
